import Text from 'components/commons/text';
import { styled } from 'styles';
import typography from 'styles/typography';

export const Card = styled('div', {
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  borderRadius: 8,
  backgroundColor: 'white',
  boxShadow: '$shadow1',
  alignItems: 'center',
  px: 16,
  py: 20,
  mb: 16,
  position: 'relative',
  '@md': {
    px: 32,
    py: 24,
  },
});

export const SmallLabel = styled(Text, {
  color: '$typeGray',
  mb: 4,
  ...typography.body6,
  '@md': {
    ...typography.body5,
  },
});

export const BigTimeText = styled(Text, {
  color: '$primary',
});

export const DesktopTimeContainer = styled('div', {
  display: 'none',
  '@md': {
    display: 'flex',
    flexDirection: 'column',
  },
});
export const BookingLabelText = styled(Text, {
  ...typography.body6,
  '@xs': typography.body5,
  '@md': typography.body2,
});
export const BookingIdText = styled(Text, {
  ...typography.body6,
  '@xs': typography.body5,
  '@md': typography.body2,
});
export const TopContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  mb: 16,
  '@xl': {
    display: 'none',
    mb: 0,
  },
});

export const ReminderBox = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  backgroundColor: '$neutral1',
  borderRadius: 4,
  px: 20,
  py: 8,
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  '@sm': {
    flexDirection: 'row',
  },
  '@lg': {
    padding: 10,
  },
});

export const ReminderText = styled(Text, {
  ...typography.body4,
  '@sm': {
    ...typography.body3,
    pr: 8,
  },
  textAlign: 'center',
});

export const ReminderClock = styled(Text, {
  mt: 8,
  ...typography.headline6,
  '@sm': {
    ...typography.headline5,
    mt: 0,
  },
  fontWeight: 'bold !important',
});

export const DateText = styled(Text, {
  ...typography.body5,
  '@xs': {
    ...typography.body4,
  },
  '@md': {
    ...typography.body2,
  },
  fontWeight: '600 !important',
});

export const CruiseText = styled(Text, {
  display: 'none',
  '@md': {
    display: 'flex',
    ...typography.headline5,
    fontSize: 20,
  },
  fontWeight: '600 !important',
});

export const TimeText = styled(Text, {
  ...typography.headline7,
  fontSize: 12,
  '@md': {
    ...typography.headline4,
  },
});

export const PortText = styled(Text, {
  ...typography.headline7,
  fontSize: 12,
  '@md': {
    ...typography.headline5,
  },
});

export const LocationText = styled(Text, {
  color: '$typeGray',
  ...typography.body5,
  '@md': {
    ...typography.body3,
  },
  fontWeight: '600 !important',
});

export const FacilityContentText = styled(LocationText, {
  color: '$typeBlack',
});

export const CruiseContentText = styled(LocationText, {
  color: '$typeBlack',
  '@xs': typography.body2,
});
export const PriceText = styled(Text, {
  ...typography.headline7,
  '@md': {
    ...typography.headline4,
  },
  fontWeight: '700 !important',
});

export const CardFooter = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  borderTop: '1px solid $dbGray1',
  mt: 16,
  pt: 16,
  width: '100%',
  '@md': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export const styles = {
  totalText: {
    color: '$typeGray',
    ...typography.body4,
    '@md': {
      ...typography.body3,
    },
    fontWeight: '600 !important',
  },
  priceContainer: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'space-between',
    flexDirection: 'row',
    '@lg': {
      justifyContent: 'flex-start',
      alignItems: 'flex-end',
      flexDirection: 'column',
    },
  },
  rightSideContainer: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingTop: 16,
    '@xl': {
      paddingTop: 0,
      alignItems: 'flex-end',
    },
  },
  selectButton: {
    '@sm': {
      minWidth: 110,
    },
  },
  passengerVehicleContainer: {
    flexDirection: 'column',
    '& > *:not(:first-child)': {
      mt: 16,
    },
    '@md': {
      '& > *:not(:first-child)': {
        mt: 0,
        ml: 16,
      },
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
  },
  bottomContainer: {
    flexDirection: 'column',
    '@lg': {
      flexDirection: 'row',
    },
  },
  breakPoints: {
    width: '100%',
    '@sm': {
      maxWidth: 576,
    },
    '@md': {
      maxWidth: 768,
    },
    '@lg': {
      maxWidth: 992,
    },
    '@xl': {
      maxWidth: 1200,
    },
  },
};
export const Gap = styled('div', {
  width: 16,
  height: 16,
  marginRight: 16,
  '@md': {
    width: 24,
    height: 24,
    marginRight: 24,
  },
});
export const HiddenGap = styled('div', {
  display: 'flex',
  width: 0,
  height: 0,
});
